<template>
  <div>
    <div class="row">
      <div class="col-lg-12 col-xxl-12">
        <div class="card card-custom gutter-b" :class="{ 'mt-4': isEmbedded }">
          <div class="card-header border-0 py-5">
            <h3 class="card-title align-items-start flex-column">
              <span class="card-label font-weight-bolder text-dark">
                แต้มหมดอายุ
              </span>
              <span class="text-muted mt-1 font-weight-bold font-size-sm">
                ตั้งค่าอายุของแต้ม และดูประวัติการแก้ไขการตั้งค่า
              </span>
            </h3>
          </div>

          <div class="card-body pt-0 pb-10">
            <b-tabs content-class="pt-8">
              <b-tab title="ตั้งค่า">
                <point-expire-config
                  :company-id="companyId"
                  @saved="configVersion += 1"
                />
              </b-tab>
              <b-tab title="ประวัติการแก้ไข" lazy>
                <point-expire-config-history
                  :company-id="companyId"
                  :reload-key="configVersion"
                />
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import PointExpireConfig from "./components/PointExpireConfig.vue";
import PointExpireConfigHistory from "./components/PointExpireConfigHistory.vue";

export default {
  name: "PointExpire",
  components: { PointExpireConfig, PointExpireConfigHistory },
  props: {
    companyId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      configVersion: 0
    };
  },
  computed: {
    isEmbedded() {
      return this.companyId !== null;
    }
  },
  mounted() {
    if (!this.isEmbedded) {
      this.setBreadcrumb();
    }
  },
  methods: {
    setBreadcrumb() {
      this.$store.dispatch(SET_BREADCRUMB, [
        {
          title: `${this.$t("MENU.COMPANY_MANAGEMENT.TITLE")}`,
          route: "/company"
        },
        { title: "แต้มหมดอายุ" }
      ]);
    }
  }
};
</script>
